import { useIsCurrentUserDadoEmployee } from '../../services/currentUser';
import { useFeatureEnabled } from '../../services/features';

// Single source of truth for how the current user may reach the AI chat window.
// copilotMode: the normal Copilot (AI_COPILOT flag).
// troubleshooterMode: Dado-staff bypass into the SAME ChatWindow when the Copilot
// flag is OFF — surfaced from the user menu so support
// staff can diagnose without the customer having the Copilot flag.
export const useCopilotAccess = () => {
  const hasCopilotFlag = useFeatureEnabled('AI_COPILOT');
  const isDadoEmployee = useIsCurrentUserDadoEmployee();

  const copilotMode = hasCopilotFlag;
  const troubleshooterMode = !hasCopilotFlag && isDadoEmployee;

  return { copilotMode, troubleshooterMode, canAccess: copilotMode || troubleshooterMode };
};